import { useSelector } from "react-redux";
import PanelLayout from "../../../layouts/PanelLayout";
import React from "react";
import { Container, Card, Row, Col, Alert, ListGroup } from "react-bootstrap";

function InicioData() {
  const usuario = useSelector((state) => state.usuario);
  const alumno = useSelector((state) => state.alumno);
  const ctacte = useSelector((state) => state.ctacte);

  const hoy = new Date();
  const mesActual = hoy.getMonth() + 1;
  const anioActual = hoy.getFullYear();
const anioSiguiente = hoy.getFullYear()+1;
  const formatMoney = (n) =>
    new Intl.NumberFormat("es-AR", { minimumFractionDigits: 0 }).format(
      Number(n || 0)
    );

  // -----------------------------
  // Cuotas tipo C (tu lógica original)
  // -----------------------------
  const cuotas = ctacte?.filter((item) => item.codcomprobante === "C") || [];
  const cuotasImpagas = cuotas.filter((cuota) => {
    const cuotaMes = Number(cuota.mes);
    const cuotaAnio = Number(cuota.anio);
    const total = Number(cuota.debe || 0) + Number(cuota.interes || 0);

    const esMesSiguiente =
      (cuotaAnio === anioActual && cuotaMes === mesActual + 1) ||
      (mesActual === 12 && cuotaAnio === anioActual + 1 && cuotaMes === 1);

    if (cuotaMes === 0 || total === 0 || esMesSiguiente) return false;
    if (cuotaAnio < 2025) return false;

    const estaPagada = ctacte.some(
      (mov) =>
        (mov.codcomprobante === "FC" || mov.codcomprobante === "FE") &&
        Number(mov.idInternoComprobantePagado) ===
          Number(cuota.idInternoComprobante)
    );

    const vencida =
      cuotaAnio < anioActual ||
      (cuotaAnio === anioActual && cuotaMes <= mesActual);

    return !estaPagada && vencida;
  });

  // -----------------------------
  //  NUEVA PARTE: Matrícula (codcomprobante === "M")
  // -----------------------------
  // 1) Tomo todas las cuotas cuya codcomprobante === "M"
  const cuotasMatricula =
    ctacte?.filter((item) => item.codcomprobante === "M") || [];

  // 2) Filtro solo las impagas/vencidas (mismas reglas que usás para C, adaptadas)
  const cuotasMatriculaImpagas = cuotasMatricula.filter((cuota) => {
    const cuotaMes = Number(cuota.mes);
    const cuotaAnio = Number(cuota.anio);
    const total = Number(cuota.debe || 0) + Number(cuota.interes || 0);

    const esMesSiguiente =
      (cuotaAnio === anioActual && cuotaMes === mesActual + 1) ||
      (mesActual === 12 && cuotaAnio === anioActual + 1 && cuotaMes === 1);

    // Para matrícula no descartamos mes===0 explícitamente (si lo querés, activalo)
    if (total === 0 || esMesSiguiente) return false;
    if (cuotaAnio < 2025) return false;

    const estaPagada = ctacte.some(
      (mov) =>
        (mov.codcomprobante === "FC" || mov.codcomprobante === "FE") &&
        Number(mov.idInternoComprobantePagado) ===
          Number(cuota.idInternoComprobante)
    );

    const vencida =
      cuotaAnio < anioActual ||
      (cuotaAnio === anioActual && cuotaMes <= mesActual);

    return !estaPagada && vencida;
  });

  // 3) Suma total pendiente de matrícula
  const saldoPendienteMatricula = cuotasMatriculaImpagas.reduce(
    (sum, it) => sum + Number(it.debe || 0) + Number(it.interes || 0),
    0
  );

  // -----------------------------
  // Totales generales (tu original)
  // -----------------------------
  const saldoPendienteTotal = cuotasImpagas.reduce(
    (sum, it) => sum + Number(it.debe || 0) + Number(it.interes || 0),
    0
  );

  // Agrupar por mes/año (usa cuotasImpagas - como tenías)
  const resumenPorMes = {};
  cuotasImpagas.forEach((it) => {
    const key = `${it.mes}/${it.anio}`;
    const monto = Number(it.debe || 0) + Number(it.interes || 0);
    resumenPorMes[key] = (resumenPorMes[key] || 0) + monto;
  });

  const cuotasAgrupadas = Object.entries(resumenPorMes)
    .map(([mesAnio, total]) => {
      const [mes, anio] = mesAnio.split("/").map(Number);
      return { mes, anio, total };
    })
    .sort((a, b) => b.anio - a.anio || b.mes - a.mes);

  // Para mostrar detalle de matrícula agrupado por mes/año (opcional, compacto)
  const resumenMatriculaPorMes = {};
  cuotasMatriculaImpagas.forEach((it) => {
    const key = `${it.mes}/${it.anio}`;
    const monto = Number(it.debe || 0) + Number(it.interes || 0);
    resumenMatriculaPorMes[key] = (resumenMatriculaPorMes[key] || 0) + monto;
  });
  const matriculaAgrupada = Object.entries(resumenMatriculaPorMes)
    .map(([mesAnio, total]) => {
      const [mes, anio] = mesAnio.split("/").map(Number);
      return { mes, anio, total };
    })
    .sort((a, b) => b.anio - a.anio || b.mes - a.mes);

  // -----------------------------
  // RENDER
  // -----------------------------
  return (
    <PanelLayout>
      <Container>
        <div className="d-flex justify-content-between border-bottom">
          <h1 className="h2 fw-bold text-dark m-0">Estado de Factura</h1>
        </div>

        <div className="py-3" data-aos="fade-up">
          <Card className="shadow-sm border-0" style={{ overflow: "hidden" }}>
            <Card.Body
              className="p-3 p-md-4"
              style={{ background: "aliceblue", color: "black" }}
            >
              {/* Familia */}
              <h5 className="mb-3">
                <strong>Familia:</strong>{" "}
                <span style={{ wordBreak: "break-word" }}>
                  {usuario?.familia?.apellido || "-"}
                </span>
              </h5>

              {/* Info alumnos */}
              <Row className="g-2 align-items-start text-break info-grid">
                <Col xs={4}>
                  <label className="form-label fw-bold m-0 titulo">
                    Alumnos
                  </label>
                  <ul className="list-unstyled mb-0 mt-1">
                    {alumno?.map((al, i) => (
                      <li key={i} className="text-uppercase">
                        {al?.nombre}
                      </li>
                    ))}
                  </ul>
                </Col>

                <Col xs={5}>
                  <label className="form-label fw-bold m-0 titulo">Nivel</label>
                  <ul className="list-unstyled mb-0 mt-1">
                    {alumno?.map((al, i) => (
                      <li key={i}>{al?.nivel}</li>
                    ))}
                  </ul>
                </Col>

                <Col xs={3}>
                  <label className="form-label fw-bold m-0 titulo">
                    Importe
                  </label>
                  <ul className="list-unstyled mb-0 mt-1">
                    {alumno?.map((al, i) => (
                      <li key={i}>
                        $
                        {new Intl.NumberFormat("es-AR").format(
                          al?.importefinal || 0
                        )}
                      </li>
                    ))}
                  </ul>
                  <hr className="my-2" />
                  <div className="fw-bold">
                    Total: $
                    {new Intl.NumberFormat("es-AR").format(
                      alumno?.reduce(
                        (s, al) => s + Number(al?.importefinal || 0),
                        0
                      ) || 0
                    )}
                  </div>
                </Col>
              </Row>

              {/* Saldo pendiente */}
              <div className="mt-3">
                <label className="form-label fw-bold">
                  Saldo pendiente total al {mesActual}/{anioActual}:
                </label>

                {saldoPendienteTotal <= 0 ? (
                  <Alert variant="success" className="py-2 mb-2">
                    ✔ No registra deuda (en concepto de cuotas mensuales)
                  </Alert>
                ) : (
                  <Alert variant="warning" className="mb-2">
                    <div className="fw-bold mb-2">
                      ⚠ Saldo pendiente: ${formatMoney(saldoPendienteTotal)}
                    </div>

                    {/* Lista compacta en mobile */}
                    <ListGroup variant="flush">
                      {cuotasAgrupadas.map((it, idx) => (
                        <ListGroup.Item
                          key={idx}
                          className="px-0 d-flex justify-content-between align-items-center"
                          style={{ background: "transparent" }}
                        >
                          <span className="text-truncate">
                            {new Date(it.anio, it.mes - 1).toLocaleString(
                              "es-AR",
                              {
                                month: "long",
                                year: "numeric",
                              }
                            )}
                          </span>
                          {/* Si querés mostrar el monto por mes, descomenta la línea de abajo */}
                          {/* <span className="fw-semibold">${formatMoney(it.total)}</span> */}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </Alert>
                )}
              </div>
 
              <div className="mt-3">
                <Alert
                  variant="info"
                  className="small mb-2"
                  style={{ lineHeight: 1.4 }}
                >
                  <strong>Cuotas adeudadas:</strong> El cobro se hará al valor
                  vigente a la fecha de pago, más intereses si corresponde. Las
                  cuotas abonadas luego del día 10 del mes sufrirán un recargo
                  del 3% sobre su valor inicial más tasa activa Banco de La
                  Pampa.
                </Alert>

               {/*    <Alert
                  variant="info"
                  className="small mb-0"
                  style={{ lineHeight: 1.5 }}
                >
               <strong>Valor Matrícula 2026:</strong>

                  <div className="mt-2">
                    <strong>✅ Matrícula sin Inglés:</strong>
                    <ul className="mb-2" style={{ paddingLeft: "1.2rem" }}>
                      <li>
                        $450.000 → Jardín de Tres Años, Jardín de Cuatro Años,
                        Preescolar
                      </li>
                      <li>
                        $384.000 → Primer Grado, Segundo Grado, Tercer Grado,
                        Cuarto Grado, Quinto Grado, Sexto Grado
                      </li>
                      <li>
                        $396.000 → Primer Secundario, Segundo Secundario, Tercer
                        Secundario
                      </li>
                      <li>
                        $428.000 → Cuarto Secundario, Quinto Secundario, Sexto
                        Secundario
                      </li>
                    </ul>

                    <strong>✅ Matrícula con Inglés:</strong>
                    <ul style={{ paddingLeft: "1.2rem" }}>
                      <li>
                        $638.000 → Primer Grado, Segundo Grado, Tercer Grado
                      </li>
                      <li>
                        $670.000 → Cuarto Grado, Quinto Grado, Sexto Grado
                      </li>
                      <li>
                        $682.000 → Primer Secundario, Segundo Secundario, Tercer
                        Secundario
                      </li>
                      <li>
                        $704.000 → Cuarto Secundario, Quinto Secundario, Sexto
                        Secundario
                      </li>
                    </ul>

                    <div className="mt-3">
                      <strong>📌 Matrícula ciclo escolar 2026 :</strong>
                      Se podrá abonar en{" "}
                      <strong>4 cuotas a partir del mes de septiembre</strong>,
                      distribuidas de la siguiente manera:
                      <ul
                        style={{ paddingLeft: "1.2rem", marginTop: "0.3rem" }}
                      >
                        <li>15% en septiembre</li>
                        <li>15% en octubre</li>
                        <li>15% en noviembre</li>
                        <li>55% en diciembre</li>
                      </ul>
                    </div>
                  </div>
                </Alert>
             */}
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </PanelLayout>
  );
}

export default InicioData;
